import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import PhoneCaseForm from '../PhoneCaseForm/PhoneCaseForm';
import { PHONE_CASE_FORM_DEFAULT_VALUES } from '../PhoneCaseForm/constants';
import { useModals } from 'hooks/useModals';
import { TPhoneCasesEdit } from './PhoneCasesEdit.types';
import { useAppDispatch, useAppSelector } from 'store/store';
import { TPhoneCaseFormValues } from '../PhoneCaseForm/PhoneCaseForm.types';
import {
  getPhoneCasesListAsyncThunk,
  updatePhoneCaseAsyncThunk,
} from 'store/phoneCases/phoneCases.action';
import { yupResolver } from '@hookform/resolvers/yup';
import { getPhoneCaseFormSchema } from '../PhoneCaseForm/PhoneCaseForm.schema';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { getLocalizationList } from 'store/localization/localization.action';
import { ESupportedLocales } from 'store/localization/localization.enums';

const PhoneCasesEdit: TPhoneCasesEdit = ({ item }) => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();
  const modals = useModals();

  const { isLoading: isUpdatePhoneCaseLoading } = useAppSelector(
    (store) => store.phoneCases.updatePhoneCase
  );

  const phoneCaseFormSchema = React.useMemo(
    () => getPhoneCaseFormSchema(localize),
    [localize]
  );

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      ...PHONE_CASE_FORM_DEFAULT_VALUES,
      ...item,
      name: localize(item.name) as string,
      description: localize(item.description) as string,
      customFields: item.customFields?.map?.((customField) => ({
        ...customField,
        name: localize(customField.name) as string,
        placeholder: localize(customField.placeholder) as string,
      })),
    },
    resolver: yupResolver(phoneCaseFormSchema),
    shouldUnregister: false,
  });

  const handleSubmit = (
    data: TPhoneCaseFormValues,
    images: Array<File | string>
  ) => {
    dispatch(
      updatePhoneCaseAsyncThunk({
        id: item.id,
        body: { ...data, images, id: item.id },
        onSuccess: () => {
          modals.closeModal();
          dispatch(getLocalizationList({ locale: ESupportedLocales.EN }));
          dispatch(
            getPhoneCasesListAsyncThunk({
              queryParams: { page: 1, perPage: 1000 },
            })
          );
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <PhoneCaseForm
        onSubmit={handleSubmit}
        defaultImageLinks={item.images}
        isLoading={isUpdatePhoneCaseLoading}
      />
    </FormProvider>
  );
};

export default PhoneCasesEdit;
